import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "@/firebase";

/**
 * Met à jour les infos utilisateur dans la table Users
 * @param {string} userId - L'ID de l'utilisateur
 * @param {Object} userInfos - Les infos à mettre à jour
 * @returns {Promise<void>}
 */
export async function updateUserInfos(userId, userInfos) {
  if (!userId) throw new Error("userId manquant");
  const docRef = doc(db, "User", userId);
  try {
    const snap = await getDoc(docRef);
    const existing = snap.exists() ? snap.data() : {};
    await setDoc(docRef, { ...existing, ...userInfos, updatedAt: Date.now() });
  } catch (e) {
    console.error("❌ Erreur update user infos :", e);
    throw e;
  }
}
